// Cart auto-add
window.addEventListener("abra:cart:changed", () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("ajaxProduct:added", {
        bubbles: true,
      })
    );
  });